import React from 'react';
import Lottie from 'lottie-react';
import animation from './animation.json';

const FavoriteScreenAnimation = () => <Lottie animationData={ animation } />;

export default FavoriteScreenAnimation;
